import axios from "axios";
import { APIClient } from "../../../../helpers/api_helper";
import * as url from "../../../../helpers/url_helper";

const api = new APIClient();

  export const createRole= async (data) => {
      try {
        const response = await api.create(url.ADD_ROLE, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getRoles = async () => {
      try {
        const response = await api.get(url.GET_ROLES);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getRoleById = async (id) => {
      try {
        const response = await api.get(`/roles/${id}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updateRole = async ( id, data) => {
      try {
        const response = await axios.put(url.UPDATE_ROLE +'/'+id, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteRole = async (id) => {
    try {
        const response = await api.delete(url.DELETE_ROLE +'/'+id);
        return response;
    } catch (error) {
        throw error;
    }
  };
